import { dispatcher, api, RESOURCE_FETCH } from '@unicus/react-ui-kit';

export const PRODUCTMOVEMENT = 'PRODUCTMOVEMENT';

export const PRODUCTMOVEMENT_DELETE = 'PRODUCTMOVEMENT_DELETE';
export const PRODUCTMOVEMENT_DELETE_FINISHED =
  'PRODUCTMOVEMENT_DELETE_FINISHED';

export const fetch = (resource, params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'product-movements',
    actionType: RESOURCE_FETCH,
    effect: async () => api.fetch('product-movements/items', params)
  });
};

export const remove = (id) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'product-movements',
    actionType: PRODUCTMOVEMENT_DELETE,
    effect: async () => api.del('product-movements', id)
  });
};
